import { demoUser } from '../config';
import { route, type DemoRoute } from '../router';

// Currency, accounts, users, processing-job polling and other small endpoints.

const accounts = [
  { code: '204', name: 'Машини и оборудване', category: 'ДМА', level: 1 },
  { code: '206', name: 'Компютърна техника', category: 'ДМА', level: 1 },
  { code: '302', name: 'Материали', category: 'Материални запаси', level: 1 },
  { code: '401', name: 'Доставчици', category: 'Разчети', level: 1 },
  { code: '402', name: 'Доставчици по аванси', category: 'Разчети', level: 1 },
  { code: '411', name: 'Клиенти', category: 'Разчети', level: 1 },
  { code: '4531', name: 'ДДС на покупките', category: 'Разчети', level: 1 },
  { code: '4532', name: 'ДДС на продажбите', category: 'Разчети', level: 1 },
  { code: '503', name: 'Разплащателна сметка', category: 'Парични средства', level: 1 },
  { code: '601', name: 'Разходи за материали', category: 'Разходи', level: 1 },
  { code: '602', name: 'Разходи за външни услуги', category: 'Разходи', level: 1 },
  { code: '609', name: 'Други разходи', category: 'Разходи', level: 1 },
  { code: '650', name: 'Разходи за бъдещи периоди', category: 'Разходи', level: 1 },
  { code: '702', name: 'Приходи от продажби на стоки', category: 'Приходи', level: 1 },
];

export const miscHandlers: DemoRoute[] = [
  route('GET', '/accounts', () => ({ accounts })),

  // Currency — the demo world is EUR-only unless a fixture says otherwise.
  route('GET', '/currency-definitions', () => ({
    common: [
      { code: 'EUR', name: 'Евро', symbol: '€', is_common: true, is_active: true, display_order: 1 },
      { code: 'USD', name: 'Щатски долар', symbol: '$', is_common: true, is_active: true, display_order: 2 },
      { code: 'GBP', name: 'Британска лира', symbol: '£', is_common: true, is_active: true, display_order: 3 },
    ],
    other: [
      { code: 'BGN', name: 'Български лев (изведен)', symbol: 'лв', is_common: false, is_active: true, display_order: 10 },
      { code: 'CHF', name: 'Швейцарски франк', is_common: false, is_active: true, display_order: 11 },
    ],
  })),
  route('GET', '/currency/rates', ({ query }) => {
    const code = query.get('currency_code');
    const rates = [
      { id: 'rate-usd', currency_code: 'USD', rate_date: '2026-07-05', rate_to_eur: 0.9214, source: 'ECB', created_at: '2026-07-05T06:00:00Z' },
      { id: 'rate-gbp', currency_code: 'GBP', rate_date: '2026-07-05', rate_to_eur: 1.1682, source: 'ECB', created_at: '2026-07-05T06:00:00Z' },
      { id: 'rate-bgn', currency_code: 'BGN', rate_date: '2026-07-05', rate_to_eur: 0.51129, source: 'фиксиран', created_at: '2026-07-05T06:00:00Z' },
    ];
    return code ? rates.filter((r) => r.currency_code === code) : rates;
  }),
  route('GET', '/currency-definitions/affected-invoices-count', () => ({ count: 0 })),
  route('POST', '/currency/rates/manual', ({ body }) => ({
    id: `rate-manual-${Date.now()}`,
    source: 'ръчен',
    created_at: new Date().toISOString(),
    ...(body as object),
  })),

  // Users / admin
  route('GET', '/users/mirage-users', () => ({
    database_name: 'Mirage',
    users: [
      { id: 1, username: 'demo', full_name: 'Демо Потребител', is_active: true },
      { id: 2, username: 'mariela', full_name: 'Мариела Иванова', is_active: true },
      { id: 3, username: 'petya', full_name: 'Петя Георгиева', is_active: true },
    ],
  })),
  route('GET', '/users/:id', () => demoUser),
  route('GET', '/auth/password-policy', () => ({
    min_length: 8,
    require_uppercase: true,
    require_lowercase: true,
    require_digit: true,
    require_special: true,
  })),

  // Job status polling — jobs complete instantly in the demo (invoice
  // "processing" progression is driven by the invoices handler instead).
  route('GET', '/processing/jobs/:jobId/status', ({ params }) => ({
    job_id: params.jobId,
    status: 'completed',
    progress: 100,
    current_step: 'готово',
  })),
  route('GET', '/processing/queue-jobs/:jobId/status', ({ params }) => ({
    job_id: params.jobId,
    status: 'completed',
    progress: 100,
    current_step: 'Правилото е записано',
  })),
];
